// extracted by mini-css-extract-plugin
export var box = "V_xV";
export var btnBase = "V_d1";
export var boxBtn = "V_xW V_d1";
export var btnWrapper = "V_d2";
export var closeBtn = "V_xX V_d1";
export var boxIcon = "V_xY";